module.exports = __webpack_public_path__ + "static/media/YARA KAHWATIYE.b66e739e.png";